export default {
  storeLocationList(state, locations) {
    state.locations = locations;
  },
  storeLocation(state, location) {
    state.location = location;
  },
  storeUpdatedLocation(state, updatedLocation) {
    state.location = updatedLocation;
  },
  storeCreatedLocation(state, createdlocation) {
    state.locations << createdlocation;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/locations/mutations.js